import src from "IMAGE";
export default { src, width: 209, height: 239, blurWidth: 0, blurHeight: 0};
